<template>
    <div>
        <v-data-table :headers="headers" :items="dispositivos" disable-pagination hide-default-footer>
            <template v-slot:[`item.plataforma`]="{ item }">
                <v-icon :title="tituloPlataforma(item)" :color="corIconePlataforma(item)">{{
                    iconePlataforma(item)
                    }}</v-icon>
            </template>
            <template v-slot:[`item.opcao`]="{ item }">
                <span>
                    <v-btn v-if="item.status" small rounded color="error" @click="alterarStatus(item)">
                        <v-icon>block</v-icon>Desativar
                    </v-btn>
                    <v-btn v-if="!item.status" small rounded color="success" title="Desativar"
                        @click="alterarStatus(item)">
                        <v-icon>check</v-icon>Ativar
                    </v-btn>
                </span>
            </template>
            <template v-slot:[`item.chaveFB`]="{ item }">
                <span>
                    <!--<v-btn small rounded color="yellow" @click="alterarFBApiKey(item)">
						<v-icon>mdi-restore</v-icon>Redefinir
					</v-btn>-->
                    <v-btn small rounded color="yellow" @click="enviaNotificacaoTeste(item)">
                        <v-icon>mdi-test-tube</v-icon>Testar
                    </v-btn>
                </span>
            </template>
        </v-data-table>
    </div>
</template>
<script>
export default {
    props: ['dispositivos'],
    data: () => ({
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'UUID', value: 'dispositivouuid' },
            { text: 'Modelo', value: 'modelo' },
            { text: 'Plataforma', value: 'plataforma', align: 'center', sortable: false },
            { text: 'Versão', value: 'versao', align: 'end', sortable: false },
            { text: 'Último Úsuário', value: 'ultusuario' },
            { text: 'Chave Notificação', value: 'chaveFB', align: 'center', sortable: false },
            { text: 'Acesso App', align: 'center', value: 'opcao', sortable: false }
        ]
    }),
    methods: {
        tituloPlataforma(item) {
            if (item.plataforma == 'iOS') return 'iOS'
            if (item.plataforma == 'Android') return 'Android'
            return ''
        },
        iconePlataforma(item) {
            if (item.plataforma == 'iOS') return 'mdi-apple'
            if (item.plataforma == 'Android') return 'android'
            return 'help'
        },
        corIconePlataforma(item) {
            if (item.plataforma == 'iOS') return 'grey lighten-1'
            if (item.plataforma == 'Android') return 'green'
            return 'blue'
        },
        async alterarStatus(item) {
            try {
                const response = await this.axios.put(
                    `/dispositivos/${item.id}/alterarstatus`,
                    { status: !item.status },
                    { baseURL: 'https://api.notifica.sicplug.com.br' }
                )

                if (response.data.valido) {
                    this.$store.dispatch('showSuccess', response.data.mensagem)
                    this.$emit('dispositivosChanged')
                } else {
                    this.$store.dispatch('showError', response.data.mensagem)
                }
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        },
        // async alterarFBApiKey(item) {
        //     try {
        //         const response = await this.axios.put('/api/dispositivos/fbapikey', {
        //             token: item.emp_chavedispositivo,
        //             uuid: item.dis_uuid,
        //             Fb_api_key: ''
        //         })

        //         if (response.data.valido) {
        //             this.$store.dispatch(
        //                 'showSuccess',
        //                 'Chave de notificações redefinida, será necessário abrir o app novamente'
        //             )
        //             this.$emit('dispositivosChanged')
        //         } else {
        //             this.$store.dispatch('showError', response.data.mensagem)
        //         }
        //     } catch (error) {
        //         this.$store.dispatch('showError', error)
        //     }
        // },
        async enviaNotificacaoTeste(item) {
            try {
                let date = new Date().toLocaleDateString()
                let time = new Date().toLocaleTimeString()

                const response = await this.axios.post(
                    `/notificacao/${item.id}/teste`,
                    { date, time },
                    { baseURL: 'https://api.notifica.sicplug.com.br' }
                )

                this.$store.dispatch(response.data.valido ? 'showSuccess' : 'showError', response.data.msg)
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
        }
    }
}
</script>
